import React, { Component } from 'react'

export default class Education extends Component {
    render() {
        return (
            <div>
                <div className="w3-container w3-card w3-white">
                    <h2 className="w3-text-grey w3-padding-16"><i className="fa fa-certificate fa-fw w3-margin-right w3-xxlarge w3-text-dark-grey"></i>Educación</h2>
                    <div className="w3-container">
                        <h5 className="w3-opacity"><b>Universidad Bolivariana de Venezuela / Licenciatura</b></h5>
                        <h6 className="w3-text-dark-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>2017 - 2019</h6>
                        <p>Mi proyecto final consistió en el desarrollo de una aplicación web que contara con API’S REST para que se comunicara con una aplicación móvil. Esta fue utilizada como prototipo para ser implementada en el área laboral en cual desempeñaba.</p>
                        <hr/>
                    </div>
                    <div className="w3-container">
                        <h5 className="w3-opacity"><b>Universidad Bolivariana de Venezuela / TSU</b></h5>
                        <h6 className="w3-text-dark-grey"><i className="fa fa-calendar fa-fw w3-margin-right"></i>2013 - 2016</h6>
                        <p>Mi proyecto para obtener el título de Técnico Superior de Grado fue el de desarrollar una aplicación móvil bautizada como cuadernillo móvil para el registro de actividades pesqueras.</p>
                        <hr/>
                    </div>
                </div>
            </div>
        )
    }
}
